import {useState} from 'react';

import styled from 'styled-components';

import {getLocalizationService} from '~/shared/services/localisationService';
import {PriceLabel} from '~/shared/components/PriceLabels';
import {PaymentMethodTypes} from '~/shared/consts/paymentConsts';
import dropDownArrowUrl from '~/assets/images/icons/drop_down_arrow.svg';
import ImageWithAlt from '~/shared/components/ImageWithAlt';
import Button from '~/shared/components/Button';
import {Row} from '~/shared/components/UserTransactions/components/styled';

const CollapseIcon = styled(ImageWithAlt).attrs({
  src: dropDownArrowUrl,
  noAlt: true,
})`
  ${({$iscollapsed}: {$iscollapsed: boolean}) => $iscollapsed && 'transform: rotate(180deg);'}
  transition: transform 0.5s ease;
  width: 12px;
  height: 7px;
  align-self: center;
`;

const StyledCollapsedButton = styled(Button)`
  width: 23px;
  height: 23px;
`;

const PaymentMethodWrapper = styled.div`
  width: 120px;
`;

const CardSuffixWrapper = styled.div`
  flex: 1;
`;

type MobileTotalRowProps = {
  paymentMethod: string;
  paymentMethodLabel: string;
  cardSuffix: string;
  total: number;
  usageBruto: number;
  usageNet: number;
  businessMeetingGuestTotal: number;
  personalGuestTotal: number;
  subsidizedMeals: number;
  nettMeals: number;
  isIntelReport: boolean;
  isKlaReport: boolean;
};

const MobileTotalRow = ({
  paymentMethod,
  paymentMethodLabel,
  cardSuffix,
  total = 0,
  usageBruto = 0,
  usageNet = 0,
  businessMeetingGuestTotal = 0,
  personalGuestTotal = 0,
  subsidizedMeals = 0,
  nettMeals = 0,
  isIntelReport,
  isKlaReport,
}: Partial<MobileTotalRowProps>) => {
  const {t} = getLocalizationService();
  const [isCollapsed, setIsCollapsed] = useState(false);
  const isMoneycard = paymentMethod === PaymentMethodTypes.MONEY_CARD;

  const shouldShowCollapseArrow = isMoneycard && (isKlaReport || isIntelReport);

  return (
    <>
      <Row spaceBetween>
        {shouldShowCollapseArrow && (
          <StyledCollapsedButton onClick={() => setIsCollapsed(!isCollapsed)}>
            <CollapseIcon $iscollapsed={isCollapsed} />
          </StyledCollapsedButton>
        )}
        <PaymentMethodWrapper>{paymentMethodLabel}</PaymentMethodWrapper>
        <CardSuffixWrapper>{cardSuffix}</CardSuffixWrapper>
        <PriceLabel price={total} bold/>
      </Row>
      {isCollapsed && isIntelReport && (
        <>
          <Row spaceBetween mobile>
            <PaymentMethodWrapper>{t('gross')}</PaymentMethodWrapper>
            <PriceLabel price={usageBruto} bold/>
          </Row>
          <Row spaceBetween mobile>
            <PaymentMethodWrapper>{t('nett')}</PaymentMethodWrapper>
            <PriceLabel price={usageNet} bold/>
          </Row>
          <Row spaceBetween mobile>
            <PaymentMethodWrapper>{t('business_guest')}</PaymentMethodWrapper>
            <PriceLabel price={businessMeetingGuestTotal} bold/>
          </Row>
          <Row spaceBetween mobile>
            <PaymentMethodWrapper>{t('personal_guest')}</PaymentMethodWrapper>
            <PriceLabel price={personalGuestTotal} bold/>
          </Row>
        </>
      )}
      {isCollapsed && isKlaReport && (
        <>
          <Row spaceBetween mobile>
            <PaymentMethodWrapper>{t('subsidized_meals')}</PaymentMethodWrapper>
            <PriceLabel price={subsidizedMeals} bold/>
          </Row>
          <Row spaceBetween mobile>
            <PaymentMethodWrapper>{t('nett_meals')}</PaymentMethodWrapper>
            <PriceLabel price={nettMeals} bold/>
          </Row>
        </>
      )}
    </>
  );
};
export default MobileTotalRow;
